import React, { ReactNode } from 'react';

import { ActionBarType } from '@hh.ru/magritte-ui-action-bar/types';

export const getScrollableParent = (node: HTMLElement | null): HTMLElement | null => {
    if (node == null) {
        return null;
    }
    if (node.scrollHeight > node.clientHeight) {
        return node;
    }
    return getScrollableParent(node.parentElement);
};

export const shouldShowDividerOrProgress = ({
    type,
    showDivider,
    showProgress,
    isScrollEnd,
}: {
    type: ActionBarType;
    showDivider: boolean | undefined;
    showProgress: ReactNode | undefined;
    isScrollEnd: boolean;
}): { shouldShowProgress: boolean; shouldShowDivider: boolean } => {
    const shouldShowProgress = type === 'mobile' ? false : React.isValidElement(showProgress);
    if (shouldShowProgress) {
        return {
            shouldShowProgress,
            shouldShowDivider: false,
        };
    }
    const shouldShowDivider = typeof showDivider === 'boolean' ? showDivider : !isScrollEnd;
    return {
        shouldShowProgress: false,
        shouldShowDivider,
    };
};
